import React from 'react';
import { Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageWrapper from 'components/Common/PageWraper';
import PageHeader from 'components/Header/Page';
import SlaStatusCard from 'components/Widgets/SlaStatusCard';
import { ReactComponent as EditIcon } from 'assets/PepWise2.0/Edit-Menu-Icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/PepWise2.0/Delete-Menu-Icon.svg';

export default function TabularView() {
    const navigate = useNavigate();

    const handleAction = (action: string, projectName: string) => {
        console.log(`${action} clicked for`, projectName);
    };

    const commonMenuProps = (projectName: string) => ({
        menuItems: [
            {
                key: 'edit',
                label: 'Edit',
                icon: <EditIcon />,
                onMenuClick: () => handleAction('edit', projectName),
            },
            {
                key: 'delete',
                label: 'Delete',
                icon: <DeleteIcon />,
                onMenuClick: () => handleAction('delete', projectName),
            },
        ],
        sx: { width: '20px', height: '20px' },
    });

    const commonTooltipProps = {
        dateValues: [
            { label: 'Date Created', value: '2026-03-09T10:00:00Z' },
            { label: 'Last Updated', value: '2026-03-10T11:00:00Z' },
        ],
    };

    return (
        <PageWrapper>
            <PageHeader title="Tabular View Demo">
                <Button variant="pepwiseSecondary" onClick={() => navigate(-1)}>
                    ← Back
                </Button>
            </PageHeader>

            <Box sx={{ mt: 3, px: 2 }}>
                <SlaStatusCard
                    projectName="Demo Project"
                    slaTime="22:00"
                    slaStatus="SLA MISSED"
                    isEditEnabled={true}
                    infoTooltip={commonTooltipProps}
                    infoOptionMenu={commonMenuProps('Demo Project')}
                />
                <SlaStatusCard
                    projectName="Active Project"
                    slaTime="18:30"
                    slaStatus="SLA MET"
                    isEditEnabled={true}
                    infoTooltip={commonTooltipProps}
                    infoOptionMenu={commonMenuProps('Active Project')}
                />
                <SlaStatusCard
                    projectName="Demo Project"
                    slaTime="22:00"
                    slaStatus="NOT STARTED"
                    isEditEnabled={true}
                    infoTooltip={commonTooltipProps}
                    infoOptionMenu={commonMenuProps('Demo Project')}
                />
                <SlaStatusCard
                    projectName="Active Project"
                    slaTime="18:30"
                    slaStatus="IN-PROGRESS"
                    isEditEnabled={true}
                    infoTooltip={commonTooltipProps}
                    infoOptionMenu={commonMenuProps('Active Project')}
                />
            </Box>

        </PageWrapper>
    );
}
